<script>
// Initialize the annoying-background directive.
export default {
  inserted(el, binding, vnode) {
    const environments = binding.value.split('|');
    if (environments) {
      if (!environments.includes(process.env.VUE_APP_AMBIENTE)) {
        try {
          vnode.elm.parentElement.removeChild(vnode.elm);
        } catch (e) {
          console.error(e);
        }
      }
    }
  }
};
</script>
